const SELECTORS = {
	container: '[data-ease-intro]',
	body: '[data-ease-body]',
	toggle: '[data-ease-toggle]',
};

export class EaseIntro {
	constructor() {
		this.containers = document.querySelectorAll(SELECTORS.container);

		if (!this.containers.length) {
			// eslint-disable-next-line no-constructor-return
			return;
		}

		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new EaseIntro();
	}

	setup() {
		this.containers.forEach((container) => {
			const toggle = container.querySelector(SELECTORS.toggle);
			const body = container.querySelector(SELECTORS.body);

			if (!toggle || !body) return;

			const moreLabel = toggle.querySelector('.ease-intro__toggle-more');
			const lessLabel = toggle.querySelector('.ease-intro__toggle-less');

			toggle.addEventListener('click', () => {
				const isExpanded = !body.hidden;

				body.hidden = isExpanded;
				moreLabel.hidden = !isExpanded;
				lessLabel.hidden = isExpanded;
			});
		});
	}
}
